import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const CircleCheck = ({ color = "darkBlue" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66699 9.99999C1.66699 5.39762 5.39795 1.66666 10.0003 1.66666C14.6027 1.66666 18.3337 5.39762 18.3337 9.99999C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 9.99999ZM13.0896 7.74407C13.415 8.0695 13.415 8.59714 13.0896 8.92258L9.75625 12.2559C9.43081 12.5814 8.90317 12.5814 8.57774 12.2559L6.91107 10.5892C6.58563 10.2638 6.58563 9.73617 6.91107 9.41073C7.23651 9.0853 7.76414 9.0853 8.08958 9.41073L9.16699 10.4881L11.9111 7.74407C12.2365 7.41863 12.7641 7.41863 13.0896 7.74407Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default CircleCheck;
